export function calculateCartTotals(workshopData, ticketsToPurchase) {
  return workshopData.ticketTypes.reduce(
    (totals, type) => {
      let quantity = ticketsToPurchase[type.name]
      let price = quantity * type.price
      return {
        quantity: totals.quantity + quantity,
        price: totals.price + price,
      }
    },
    { quantity: 0, price: 0 }
  )
}
